import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionPropsCohabitation } from 'shell/view-models/actions-props';
import { Visibility as VisibilityIcon } from '@mui/icons-material';

const ActionsList = ({ cell, form, goBackUrl }: ActionPropsCohabitation): React.ReactElement => {
  const navigate = useNavigate();

  const onVisibilityPress = useEventCallback(() => {
    return new Promise((resolve) => {
      navigate({
        pathname: goBackUrl,
        search: `?${createSearchParams({
          ricercaNazionale: form?.isNationalResearch?.toString() || 'false',
          anprId: cell?.idANPR || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list cohabitation page component';

export default ActionsList;
